import {
  getNameDescriptionTableColumn,
  getBrandTableColumn,
  getCloudEnvTableColumn,
  getAccountTableColumn,
} from '@/utils/common/tableColumn'
import i18n from '@/locales'

export default {
  created () {
    this.columns = [
      getNameDescriptionTableColumn({
        onManager: this.onManager,
        hideField: true,
        slotCallback: row => {
          return (
            <side-page-trigger onTrigger={() => this.handleOpenSidepage(row)}>{row.name}</side-page-trigger>
          )
        },
      }),
      getCloudEnvTableColumn(),
      getBrandTableColumn({ sortable: false }),
      getAccountTableColumn(),
      {
        field: 'products',
        title: i18n.t('bill.shield_res_type'),
        minWidth: 100,
        slots: {
          default: ({ row }, h) => {
            let list = []
            if (row.product) {
              list = JSON.parse(row.product)
            }
            const ret = list.map(item => {
              return <a-tag class="mb-1 mt-1">{item.product_name}</a-tag>
            })
            return [
              <list-body-cell-popover text={this.$t('common_701', [list.length])} max-width="400px" >
                <div style="display: inline-flex; flex-wrap: wrap">
                  {...ret}
                </div>
              </list-body-cell-popover>,
            ]
          },
        },
        formatter: ({ row }) => {
          let list = []
          if (row.product) {
            list = JSON.parse(row.product)
          }
          return list.map(item => item.product_name).join(', ')
        },
      },
    ]
  },
}
